<template>
    
    <div id="wrapper" style="margin-top:-9px;">

      <!-- Sidebar -->

     
<ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

  <!-- Sidebar - Brand -->
  <a class="sidebar-brand d-flex align-items-center justify-content-center"  >
      <div class="sidebar-brand-icon rotate-n-15">
          <i class="fas fa-sticky-note"></i>
      </div>
      <div class="sidebar-brand-text mx-3">Китоби ҷамоат</div>
  </a>

  <!-- Divider -->
  <hr class="sidebar-divider my-0">

  <!-- Nav Item - Dashboard -->
  <li class="nav-item">
      
      <router-link class="nav-link" to="/" >
          <i class="fas fa-fw fa-tachometer-alt"></i>
          <span>Асосӣ</span>
        </router-link>
      
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
      Дохилкунӣ
  </div>


  <!-- Nav Item - Tables -->
  <li class="nav-item ">
      
        <router-link to="/Households" class="nav-link active" > 
          <i class="fas fa-fw fa-house-user"></i>
          <span>Хоҷагиҳо</span>
      </router-link> 
  </li>


 



  <!-- Nav Item - Tables -->
  <li class="nav-item">
      <router-link to="/Books" class="nav-link " > 
          <i class="fas fa-fw fa-book"></i>
          <span>Китобҳо</span>
      </router-link>
  </li>

  <!-- Nav Item - Utilities Collapse Menu -->
  <li class="nav-item">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities"
         aria-expanded="true" aria-controls="collapseUtilities">
          <i class="fas fa-fw fa-search"></i>
          <span>Ҷустуҷӯ</span>
      </a>
      <div id="collapseUtilities" class="collapse" aria-labelledby="headingUtilities"
           data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Шаклҳо:</h6>
              <router-link class="collapse-item" to="/Search" active-class="active">Аҳолӣ</router-link>
             <router-link class="collapse-item" to="/Search2" active-class="active">Хоҷагиҳо</router-link>
      



          </div>
      </div>
  </li>



  <!-- Nav Item - Utilities Collapse Menu -->
  <li class="nav-item">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseUtilities2"
         aria-expanded="true" aria-controls="collapseUtilities2">
          <i class="fas fa-fw fa-search"></i>
          <span>Тафтиш</span>
      </a>
      <div id="collapseUtilities2" class="collapse" aria-labelledby="headingUtilities"
           data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Шаклҳо:</h6>
              <router-link class="collapse-item" to="/Check/1" active-class="active">Замин</router-link>
              <router-link class="collapse-item" to="/Check/2" active-class="active">Чорво</router-link>
              <router-link class="collapse-item" to="/Check/3" active-class="active">Техника</router-link>
             <!-- <router-link class="collapse-item" to="/Search2" active-class="active">Хоҷагиҳо</router-link> -->
      



          </div>
      </div>
  </li>


  <!-- Divider -->
  <hr class="sidebar-divider">

  <!-- Heading -->
  <div class="sidebar-heading">
      Ҳисобот
  </div>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages1"
         aria-expanded="true" aria-controls="collapsePages1">
          <i class="fas fa-fw fa-folder"></i>
          <span>Аҳолӣ</span>
      </a>
      <div id="collapsePages1" class="collapse" aria-labelledby="headingPages1" data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Шаклҳо:</h6>
              <router-link class="collapse-item" to="/Report1" active-class="active">Шакли 1</router-link>
              <router-link class="collapse-item" to="/Report2" active-class="active">Шакли 2</router-link>
              <router-link class="collapse-item" to="/Report3" active-class="active">Шакли 3</router-link>
              <router-link class="collapse-item" to="/Report4" active-class="active">Шакли 4</router-link>
              <!-- <router-link class="collapse-item" to="/Report5" active-class="active">Шакли 5</router-link> -->
<router-link class="collapse-item" to="/Report6" active-class="active">Шакли 5</router-link>
    
          </div>
      </div>
  </li>

  <!-- Nav Item - Pages Collapse Menu -->
  <li class="nav-item">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages2"
         aria-expanded="true" aria-controls="collapsePages2">
          <i class="fas fa-fw fa-folder"></i>
          <span>Хоҷагӣ</span>
      </a>
      <div id="collapsePages2" class="collapse" aria-labelledby="headingPages2" data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Шаклҳо:</h6>
              
              <router-link class="collapse-item" to="/Report7" active-class="active">Шакли 1</router-link>
              <router-link class="collapse-item" to="/Report8" active-class="active">Шакли 2</router-link>
              <router-link class="collapse-item" to="/Report9" active-class="active">Шакли 3</router-link>
              <router-link class="collapse-item" to="/Report10" active-class="active">Шакли 4</router-link>
          </div>
      </div>
  </li>



  <!-- Nav Item - Pages Collapse Menu 
  <li class="nav-item">
      <a class="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapsePages3"
         aria-expanded="true" aria-controls="collapsePages3">
          <i class="fas fa-fw fa-folder"></i>
          <span>Диаграмма</span>
      </a>
      <div id="collapsePages3" class="collapse" aria-labelledby="headingPages" data-parent="#accordionSidebar">
          <div class="bg-white py-2 collapse-inner rounded">
              <h6 class="collapse-header">Шаклҳо:</h6>



              <a class="collapse-item" asp-controller="Chart" asp-action="Index1">
                  <i class="fas fa-fw fa-list-alt"></i>
                  <span>Шумораи аҳолӣ</span>
              </a>


              <a class="collapse-item" asp-controller="Chart" asp-action="Index3">
                  <i class="fas fa-fw fa-users"></i>
                  <span>Маълумотнокӣ</span>
              </a>


              <a class="collapse-item" asp-controller="Chart" asp-action="Index4">
                  <i class="fas fa-fw fa-list-alt"></i>
                  <span>Таҳсилот</span>
              </a>



              <a class="collapse-item" asp-controller="Chart" asp-action="Index5">
                  <i class="fas fa-fw fa-list-alt"></i>
                  <span>Миллат</span>
              </a>



              <a class="collapse-item" asp-controller="Chart" asp-action="Index6">
                  <i class="fas fa-fw fa-list-alt"></i>
                  <span>Нафақа</span>
              </a>



          </div>
      </div>
  </li>
-->




  <hr class="sidebar-divider d-none d-md-block">
  <!-- Nav Item - Charts -->
  <li class="nav-item">
      <router-link to="/Setting" class="nav-link active" > 
          <i class="fas fa-fw fas fa-fw fa-wrench" ></i>
          <span>Танзим</span>
      </router-link> 
  </li>


 


  <!-- Nav Item - Tables -->
  <li v-if="this.$store.state.showmenu" class="nav-item">
      <router-link to="/Tablet" class="nav-link active" >
          <i class="fas fa-fw fa-file-export"></i>
          <span>Планшет</span>
      </router-link> 
  </li>

  <!-- Divider -->
  <hr class="sidebar-divider d-none d-md-block">

  <!-- Sidebar Toggler (Sidebar) -->
  <div class="text-center d-none d-md-inline">
      <button class="rounded-circle border-0" id="sidebarToggle"></button>
  </div>

</ul>

      <!-- End of Sidebar -->
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

          <!-- Main Content -->
          <div id="content">

              <!-- Topbar -->
              <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                  <!-- Sidebar Toggle (Topbar) -->
                  <button id="sidebarToggleTop" class="btn btn-link d-md-none rounded-circle mr-3">
                      <i class="fa fa-bars"></i>
                  </button>

                  <h3 class="mr-5 text-primary">{{this.$store.state.tername}} </h3>


                  <!-- Topbar Search -->
                  <form class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                      <div class="input-group">
                          <input type="text" class="form-control bg-light border-0 small" placeholder="Ҷустуҷӯ ..."
                                 aria-label="Search" aria-describedby="basic-addon2">
                          <div class="input-group-append">
                              <button class="btn btn-primary" type="button">
                                  <i class="fas fa-search fa-sm"></i>
                              </button>
                          </div>
                      </div>
                  </form>

                  <!-- Topbar Navbar -->
                  <ul class="navbar-nav ml-auto">

                      <!-- Nav Item - Search Dropdown (Visible Only XS) -->
                      <li class="nav-item dropdown no-arrow d-sm-none">
                          <a class="nav-link dropdown-toggle" href="#" id="searchDropdown" role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fas fa-search fa-fw"></i>
                          </a>
                          <!-- Dropdown - Messages -->
                          <div class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
                               aria-labelledby="searchDropdown">
                              <form class="form-inline mr-auto w-100 navbar-search">
                                  <div class="input-group">
                                      <input type="text" class="form-control bg-light border-0 small"
                                             placeholder="Search for..." aria-label="Search"
                                             aria-describedby="basic-addon2">
                                      <div class="input-group-append">
                                          <button class="btn btn-primary" type="button">
                                              <i class="fas fa-search fa-sm"></i>
                                          </button>
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </li>

                      <!-- Nav Item - Alerts -->
                      <li class="nav-item dropdown no-arrow mx-1">
                          <a class="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fas fa-bell fa-fw"></i>
                              <!-- Counter - Alerts -->
                              <span class="badge badge-danger badge-counter">3+</span>
                          </a>
                          <!-- Dropdown - Alerts -->
                          <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                               aria-labelledby="alertsDropdown">
                              <h6 class="dropdown-header">
                                  Маркази эълонҳо
                              </h6>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="mr-3">
                                      <div class="icon-circle bg-primary">
                                          <i class="fas fa-file-alt text-white"></i>
                                      </div>
                                  </div>
                                  <div>
                                      <div class="small text-gray-500">12.10.2022</div>
                                      <span class="font-weight-bold">Маълумҳоро то санаи 30.11.2022 пурра дохил кунед!</span>
                                  </div>
                              </a>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="mr-3">
                                      <div class="icon-circle bg-success">
                                          <i class="fas fa-donate text-white"></i>
                                      </div>
                                  </div>
                                  <div>
                                      <div class="small text-gray-500">05.09.2022</div>
                                      Суратҳисоби хонаводаҳоро дар китоби 4-ум пурра намоед!
                                  </div>
                              </a>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="mr-3">
                                      <div class="icon-circle bg-warning">
                                          <i class="fas fa-exclamation-triangle text-white"></i>
                                      </div>
                                  </div>
                                  <div>
                                      <div class="small text-gray-500">6.10.2022</div>
                                      Маълумотҳои омории шакли 1-ХА ро то санаи 10-ум пешниҳод намоед
                                  </div>
                              </a>
                              <a class="dropdown-item text-center small text-gray-500" href="#">Ҳамаи эълонҳо</a>
                          </div>
                      </li>

                      <!-- Nav Item - Messages -->
                      <li class="nav-item dropdown no-arrow mx-1">
                          <a class="nav-link dropdown-toggle" href="#" id="messagesDropdown" role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <i class="fas fa-envelope fa-fw"></i>
                              <!-- Counter - Messages -->
                              <span class="badge badge-danger badge-counter">7</span>
                          </a>
                          <!-- Dropdown - Messages -->
                          <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
                               aria-labelledby="messagesDropdown">
                              <h6 class="dropdown-header">
                                  Маркази хабарҳо
                              </h6>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="dropdown-list-image mr-3">
                                      <img class="rounded-circle" src="tpl/img/undraw_profile_1.svg"
                                           alt="...">
                                      <div class="status-indicator bg-success"></div>
                                  </div>
                                  <div class="font-weight-bold">
                                      <div class="text-truncate">
                                          Хабари 1
                                      </div>
                                      <div class="small text-gray-500">Администратор</div>
                                  </div>
                              </a>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="dropdown-list-image mr-3">
                                      <img class="rounded-circle" src="tpl/img/undraw_profile_2.svg"
                                           alt="...">
                                      <div class="status-indicator"></div>
                                  </div>
                                  <div>
                                      <div class="text-truncate">
                                          Хабари 2
                                      </div>
                                      <div class="small text-gray-500">Администратор</div>
                                  </div>
                              </a>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="dropdown-list-image mr-3">
                                      <img class="rounded-circle" src="tpl/img/undraw_profile_3.svg"
                                           alt="...">
                                      <div class="status-indicator bg-warning"></div>
                                  </div>
                                  <div>
                                      <div class="text-truncate">
                                          Хабари 3
                                      </div>
                                      <div class="small text-gray-500">Администратор</div>
                                  </div>
                              </a>
                              <a class="dropdown-item d-flex align-items-center" href="#">
                                  <div class="dropdown-list-image mr-3">
                                      <img class="rounded-circle" src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
                                           alt="...">
                                      <div class="status-indicator bg-success"></div>
                                  </div>
                                  <div>
                                      <div class="text-truncate">
                                          Хабари 4
                                      </div>
                                      <div class="small text-gray-500">Администратор</div>
                                  </div>
                              </a>
                              <a class="dropdown-item text-center small text-gray-500" href="#">Ҳамаи хабарҳо</a>
                          </div>
                      </li>

                        <div class="topbar-divider d-none d-sm-block"></div>

           <li class="nav-item dropdown no-arrow ">
      

                                       <a class="nav-link dropdown-toggle"  >
                              <span class="mr-2 d-none d-lg-inline text-gray-600 small">Версия: {{ this.$store.state.version }}</span>
                          
                          </a>
                         
                      </li>
                      <div class="topbar-divider d-none d-sm-block"></div>

                      <!-- Nav Item - User Information -->
                      <li class="nav-item dropdown no-arrow">
                          <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                             data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                              <span class="mr-2 d-none d-lg-inline text-gray-600 small">Администратор   </span>
                              <img class="img-profile rounded-circle"
                                   src="/tpl/img/undraw_profile.svg">
                          </a>
                          <!-- Dropdown - User Information -->
                          <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                               aria-labelledby="userDropdown">
                              <a class="dropdown-item" href="#">
                                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                                  Профил
                              </a>
                              <a class="dropdown-item" href="#">
                                  <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
                                  Танзим
                              </a>
                              <a class="dropdown-item" href="#">
                                  <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
                                  Журнал
                              </a>
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item" href="#" data-toggle="modal" data-target="#logoutModal">
                                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                  Баромад
                              </a>
                          </div>
                      </li>

                  </ul>

              </nav>
              <!-- End of Topbar -->

              <div class="container-fluid">
                  <main role="main" class="pb-3">
                 
                    <router-view/>

                  </main>
              </div>


          </div>
          <!-- End of Main Content -->
      </div>
      <!-- End of Content Wrapper -->
  </div>




    
    <!-- built files will be auto injected -->

    <footer class="sticky-footer bg-white">
      <div class="container my-auto">
          <div class="copyright text-center my-auto">
              <span>Copyright &copy; Китоби ҷамоат 2023</span>
          </div>
      </div>
  </footer>


  <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
  </a>

  <!-- Logout Modal-->
  <div class="modal fade" id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
      <div class="modal-dialog" role="document">
          <div class="modal-content">
              <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Баромад аз барнома</h5>
                  <button class="close" type="button" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">×</span>
                  </button>
              </div>
              <div class="modal-body">Шумо ҳақиқатан мехоҳед аз <br> барнома берун шавед?</div>
              <div class="modal-footer">
                  <button class="btn btn-secondary" type="button" data-dismiss="modal">Бекоркунӣ</button>
                  <button class="btn btn-danger"  data-dismiss="modal" @click="logout">Баромад</button>
              </div>
          </div>
      </div>
  </div>


</template>

<script>


export default {
   methods:{

    logout(){

        this.$store.dispatch("logout");
        // this.$store.state.login=false;


        // this.$store.state.ter='';

        // this.$store.state.tername='';
        // this.$store.state.count= 0;
        // this.$store.state.books=[];
        // this.$store.state.households=[];
        // this.$store.state.members=[];
        // this.$store.state.data=[];
        // this.$store.state.ter=[];

        // this.$store.state.terid=0;
        // this.$store.state.book='';
        // this.$store.state.household={};
        // this.$store.state.member={};

        // this.$store.state.mid=0;
        // this.$store.state.spravka={};
    }
   }
}
</script>
